import { render } from "./GroupProfile.vue?vue&type=template&id=e24334d4&scoped=true&ts=true"
import script from "./GroupProfile.vue?vue&type=script&lang=ts"
export * from "./GroupProfile.vue?vue&type=script&lang=ts"

import "./GroupProfile.vue?vue&type=style&index=0&id=e24334d4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e24334d4"]])

export default __exports__